import { clsx, type ClassValue } from "clsx"
import { DateTime } from "luxon"
import { twMerge, extendTailwindMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const convertTimezone = (date: number) => {
  const localTz = new Date(date).getTimezoneOffset()
  const siteTz = DateTime.fromMillis(date).offset
  
  return (siteTz + localTz) * 60000
}

export const focusInput = [
  // base
  "focus:ring-2",
  // ring color
  "focus:ring-blue-200 focus:dark:ring-blue-700/30",
  // border color
  "focus:border-blue-500 focus:dark:border-blue-700",
]


export const hasErrorInput = [
  // base
  "ring-2",
  // border color
  "border-red-500 dark:border-red-700",
  // ring color
  "ring-red-200 dark:ring-red-700/30",
]

export const focusRing = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-blue-500 dark:outline-blue-500",
]

export const getSelectButtonColors = (
  hasSelection: boolean,
  isDisabled: boolean,
  hasError = false,
) => {
  return twMerge(
    isDisabled
      ? "bg-tremor-background-subtle dark:bg-dark-tremor-background-subtle"
      : "bg-tremor-background dark:bg-dark-tremor-background",
    !isDisabled && "hover:bg-tremor-background-muted dark:hover:bg-dark-tremor-background-muted",
    hasSelection
      ? "text-tremor-content-emphasis dark:text-dark-tremor-content-emphasis"
      : "text-tremor-content dark:text-dark-tremor-content",
    isDisabled && "text-tremor-content-subtle dark:text-dark-tremor-content-subtle",
    hasError && "text-red-500 placeholder:text-red-500",
    hasError ? "border-red-500" : "border-tremor-border dark:border-dark-tremor-border",
  );
};

export function hasValue<T>(value: T | null | undefined) {
  return value !== null && value !== undefined && value !== "";
}

export function mergeRefs<T = any>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>,
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}

export function makeClassName(componentName: string) {
  return (className: string) => {
    return `mattr-${componentName}-${className}`;
  };
}

export const stringToColour = (str: string) => {
  let hash = 0;
  str.split('').forEach(char => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash)
  })
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += value.toString(16).padStart(2, '0')
  }
  return colour
}

export const mode = (myArray: any[]) =>
  myArray.reduce(
    (a,b,i,arr)=>
     (arr.filter(v=>v===a).length>=arr.filter(v=>v===b).length?a:b),
  null)